/**
 * ReelGenerationSkeleton Component
 * Feature 017: Instagram Reel Creation
 * Loading skeleton for reel generation
 */

import { memo } from 'react';

interface IReelGenerationSkeletonProps {
  modelCount?: number;
}

const ReelGenerationSkeleton = ({ modelCount = 3 }: IReelGenerationSkeletonProps) => {
  // Dynamic grid class based on model count
  const gridClass =
    modelCount === 1
      ? 'grid grid-cols-1 gap-6'
      : modelCount === 2
        ? 'grid grid-cols-1 gap-6 lg:grid-cols-2'
        : 'grid grid-cols-1 gap-6 lg:grid-cols-3';

  return (
    <div className={gridClass}>
      {Array.from({ length: modelCount }).map((_, index) => (
        <div
          key={index}
          className="rounded-lg border border-gray-200 bg-gray-50 p-6 animate-pulse"
        >
          {/* Header skeleton */}
          <div className="mb-4 flex items-center justify-between">
            <div className="h-6 w-32 rounded bg-gray-200" />
            <div className="h-5 w-5 rounded-full bg-gray-200" />
          </div>

          {/* Section skeletons */}
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="mb-4 space-y-2">
              <div className="h-4 w-24 rounded bg-gray-200" />
              <div className="h-16 rounded bg-gray-100" />
            </div>
          ))}

          {/* Button skeleton */}
          <div className="mt-6 h-10 w-full rounded bg-gray-200" />
        </div>
      ))}
    </div>
  );
};

export const ReelGenerationSkeletonMemo = memo(ReelGenerationSkeleton);
